import React from "react";
import one from "../images/teams/atul.jpg";
import two from "../images/teams/harsh.png";


const Teams = [

	{
		timage: one,
		ttitle : "Co-Founder, Atul Kumar",
	},

	{
		timage: two,
		ttitle : "Co-Founder, Harsh Singh",
	},

];

export default Teams;